const projectsData = [
  {
    id: 1,
    image: "/assets/elasticbeanstalk.jpeg",
     title: "AWS Elastic Beanstalk Node.js Sample App",
    description: "I created a Continuous Delivery Pipeline.",
    sourceCode: "https://github.com/SarahWanjiru/aws-elastic-beanstalk-express-js-sample",
    //liveProject: "https://yourproject.com",
  },
  {
    id: 2,
    image: "/assets/FundiFix.png",
    title: "FundiFix - Revolutionizing how Kenya connects with skilled professionals",
    description: "FundiFix connects Kenyans with skilled fundis (artisans) through WhatsApp.",
    sourceCode: "https://github.com/SarahWanjiru/FundiFix",
    liveProject: "https://drive.google.com/file/d/1gMN-GRmEu55uy6xf-4kr3ulvrl1nUJeD/view?usp=sharing",
  },
];

export default projectsData;
